// utils/detectBrowserLang.js
export function detectBrowserLang(
  // supported = ["hu", "en", "de"],
  fallback = "hu"
) {
  // grab the first preferred locale, e.g. "en-US"
  // const raw =
  //   (navigator.languages && navigator.languages[0]) || // modern browsers
  //   navigator.language ||                              // older ones
  //   fallback;

  // const lang = raw.split("-")[0];                      // → "en"

  // return supported.includes(lang) ? lang : fallback;
  return fallback;
}